<template>
    <div class="tooltip-logbook" v-if="hasWeeks">
        <span class="tooltip-trigger">
            <router-link
                v-if="!permission_link"
                :to="relationLink()"
                v-text="weeks + ' ' + weeks === 1 ? 'week' : 'weken'"
                target="_blank"
            />
            <link-if-permissions
                v-else
                target="_blank"
                permissions="view-relations"
                :to="relationLink()"
            >
                {{ weeks }} {{ weeks === 1 ? 'week' : 'weken' }}
            </link-if-permissions>
        </span>

        <div class="tooltiptext-logbook" :class="toolTipClass">
            <div v-if="hasLogbook">
                <div class="row" style="margin: 0px !important;">
                    <strong>Onderwerp:</strong>
                    <span class="value">{{ subject }}</span>
                </div>
                <div class="row" style="margin: 0px !important;">
                    <strong>Tekst:</strong>
                    <span class="value prewrap">{{ body }}</span>
                </div>
                <div class="row" style="margin: 0px !important;">
                    <strong>Logboekcategorie:</strong>
                    <span class="value">{{ category }}</span>
                </div>
                <div class="row" v-if="subcategory != ' - '" style="margin: 0px !important;">
                    <strong>Logboeksubcategorie:</strong>
                    <span class="value">{{ subcategory }}</span>
                </div>
            </div>
            <div v-else>
                Geen logboek gevonden
            </div>
        </div>
    </div>

    <span v-else>-</span>
</template>

<script>
export default {
    name: "logbook-tooltip-field",
    props: {
        weeks: {
            required: false,
            default: null
        },
        logbook: {
            required: false,
            default: null
        },
        relation: {
            required: false,
            default: null
        },
        permission_link: {
            required: false,
            default: false
        }
    },

    computed: {
        hasWeeks() {
            return this.weeks !== null && this.weeks !== undefined;
        },

        hasLogbook() {
            return !!this.logbook;
        },

        subject() {
            const s = (this.logbook?.subject || '').toString().trim();
            return s.length ? s : '-';
        },

        body() {
            const b = (this.logbook?.body || '').toString().trim();
            return b.length ? b : '-';
        },

        category() {
          return (this.logbook?.category_name || '-').toString().trim() || '-';
        },

        subcategory() {
            return (this.logbook?.subcategory_name || '-').toString().trim() || '-';
        },

        toolTipClass() {
            // mimic the old component’s "top-one/top-two" idea
            // (you can tweak later if you want dynamic height)
            return 'right';
        }
    },
    methods: {
        relationLink() {
            return {
                name: 'admin.relations.view',
                params: {'id': this.relation.id}
            }
        },
    },
}
</script>

<style scoped>
.tooltip-logbook {
    position: relative;
    display: inline-block;
    cursor: help;
}

.tooltiptext-logbook {
    background: white;
}

/* same hover behaviour as NameTelephoneField */
.tooltip-logbook .tooltiptext-logbook {
    visibility: hidden;
    width: 360px;
    max-width: 360px;
    background-color: white;
    color: #c10f6d;
    border: 1px solid #5a458a;
    text-align: left;
    border-radius: 6px;
    padding: 10px;

    position: absolute;
    z-index: 1000;
    left: 105%;
    top: -10px;
}

.tooltip-logbook:hover .tooltiptext-logbook {
    visibility: visible;
}

/* arrow */
.tooltip-logbook .tooltiptext-logbook::after {
    content: " ";
    position: absolute;
    top: 20px;
    right: 100%;
    margin-top: -5px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent #5a458a transparent transparent;
}

.tooltip-trigger {
    display: inline-block;
}

.row {
    margin-bottom: 6px;
}

.value {
    margin-left: 6px;
}

.prewrap {
    white-space: pre-wrap;   /* keep line breaks */
    word-break: break-word;  /* break long words */
}
</style>
